import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

export const Contact = () => {
  return (
    <section className="af-section" data-testid="contact-page">
      <div className="af-container" style={{ maxWidth: 820 }}>
        <div className="af-eyebrow">Get in touch</div>
        <h1 className="af-h2" style={{ marginTop: 14, marginBottom: 24 }}>Contact</h1>

        <div className="af-lede" style={{ display: "grid", gap: 18, color: "#cfd3dc" }}>
          <p>
            Have a question, partnership idea, or want to follow what we are building? Email us directly.
          </p>

          <div
            className="af-panel"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
              <span
                aria-hidden
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  background: "rgba(183, 65, 14, 0.12)",
                  border: "1px solid rgba(183, 65, 14, 0.4)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <Mail size={18} />
              </span>
              <div>
                <div style={{ color: "var(--af-text-muted)", fontSize: "0.78rem", letterSpacing: "0.08em", textTransform: "uppercase" }}>
                  Email
                </div>
                <div style={{ color: "#fff", fontWeight: 600, fontSize: "1.05rem" }} data-testid="contact-email-text">
                  stefan@aithorityforge.com
                </div>
              </div>
            </div>
            <a
              href="mailto:stefan@aithorityforge.com"
              className="af-btn af-btn-primary"
              data-testid="contact-page-email-btn"
            >
              Send Email
            </a>
          </div>

          <div
            style={{
              display: "flex",
              gap: 12,
              alignItems: "center",
              color: "var(--af-text-muted)",
              fontSize: "0.95rem",
            }}
          >
            <MapPin size={16} />
            Regina, Saskatchewan, Canada
          </div>

          <div style={{ marginTop: 16, display: "flex", gap: 10, flexWrap: "wrap" }}>
            <Link to="/" className="af-btn af-btn-ghost" data-testid="contact-back-home">Back to home</Link>
            <Link to="/support" className="af-btn af-btn-ghost" data-testid="contact-go-support">Visit Support</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
